/** @format */

import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import {
	HomefieldPriceModule,
	HomefieldProductImageModule,
	HomefieldStrikethroughPriceModule
} from '@homefield';
import { Subject, takeUntil } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { BottomPaginationComponent } from '../bottom-pagination/bottom-pagination.component';
import { Store } from '@ngrx/store';
import { TopPaginationComponent } from '../top-pagination/top-pagination.component';
import { selectProductList } from '@plp/data-access/state';

@Component({
	selector: 'plp-components-color-breakout',
	imports: [
		AsyncPipe,
		HomefieldPriceModule,
		HomefieldProductImageModule,
		HomefieldStrikethroughPriceModule,
		TopPaginationComponent,
		BottomPaginationComponent
	],
	templateUrl: './color-breakout.component.html',
	styleUrl: './color-breakout.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorBreakoutComponent implements OnDestroy {
	private readonly destroy$ = new Subject<void>();

	readonly productListData$ = this.store.select(selectProductList).pipe(takeUntil(this.destroy$));

	constructor(private readonly store: Store) {}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	trackByFn(index: number, item: any): string {
		return index.toString() + item.parentCatentryId;
	}
}
